import React from 'react';
import { Button, Card, Stack, Typography } from '@mui/material';
import {
  bottomRowSx,
  iconBoxSx,
  infoLineSx,
  infoPairSx,
  infoSectionSx,
  mutedTextSx,
  bottomButtonSx,
  primaryTextSx,
  titleRowSx,
  topRowSx,
  walletCardSx,
  walletInnerFrameSx,
  infoLabelSx,
  infoValueSx,
} from './styles';
import { Info, Wallet } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface WalletCardProps {
    totalBalance: number;
    withdrawableBalance: number;
    creditBalance: number;
    onClose?: () => void;
}

const WalletCard: React.FC<WalletCardProps> = ({ totalBalance, withdrawableBalance, creditBalance, onClose }) => {
  const { t } = useTranslation('wallet');
  const navigate = useNavigate();

  return (
    <Card sx={walletCardSx}>
      <Stack sx={walletInnerFrameSx}>
        <Stack sx={topRowSx}>
          <Stack sx={iconBoxSx}>
            <Wallet size={25} color="#CCD4FF" />
          </Stack>
          <Stack sx={titleRowSx}>
            <Typography fontSize={20} sx={primaryTextSx}>
              {t('TOTAL_WALLET_BALANCE')}
            </Typography>
            <Typography fontSize={24} fontWeight="bold">
              {totalBalance}€
            </Typography>
          </Stack>
        </Stack>
  
        <Stack sx={infoSectionSx}>
          <Stack sx={infoLineSx}>
            <Info size={16} color="#CCD4FF" />
            <Stack sx={infoPairSx}>
              <Typography sx={infoLabelSx}>{t('WITHDRAWABLE_FUNDS')} :</Typography>
              <Typography sx={infoValueSx}>{withdrawableBalance}€</Typography>
            </Stack>
          </Stack>
          <Stack sx={infoLineSx}>
            <Info size={16} color="#CCD4FF" />
            <Stack sx={infoPairSx}>
              <Typography sx={infoLabelSx}>{t('STORE_CREDIT')} :</Typography>
              <Typography sx={infoValueSx}>{creditBalance}€</Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
  
      {/* Outside walletInnerFrameSx */}
      <Stack sx={bottomRowSx}>
        <Typography sx={mutedTextSx}>{t('WALLET_USAGE_INFO')}</Typography>
        <Button
          variant="contained"
          size="small"
          sx={bottomButtonSx}
          onClick={() => { onClose?.(); navigate('/store'); }}
        >
          {t('GO_TO_STORE')}
        </Button>
      </Stack>
    </Card>
  );
};

export default WalletCard;